export default __webpack_public_path__ + "static/media/dashBoardFilledIcon.3b69df36.svg";